/* tslint:disable */
/* eslint-disable */
/**
 * Muscula App API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DateInterval } from './DateInterval';
import {
    DateIntervalFromJSON,
    DateIntervalFromJSONTyped,
    DateIntervalToJSON,
} from './DateInterval';
import type { LogType } from './LogType';
import {
    LogTypeFromJSON,
    LogTypeFromJSONTyped,
    LogTypeToJSON,
} from './LogType';
import type { UptimeCheckDocument } from './UptimeCheckDocument';
import {
    UptimeCheckDocumentFromJSON,
    UptimeCheckDocumentFromJSONTyped,
    UptimeCheckDocumentToJSON,
} from './UptimeCheckDocument';

/**
 * 
 * @export
 * @interface LogDocument
 */
export interface LogDocument {
    /**
     * 
     * @type {string}
     * @memberof LogDocument
     */
    logId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogDocument
     */
    projectId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogDocument
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof LogDocument
     */
    notifyOnNew?: boolean;
    /**
     * 
     * @type {string}
     * @memberof LogDocument
     */
    timeZone?: string | null;
    /**
     * 
     * @type {number}
     * @memberof LogDocument
     */
    timeZoneOffset?: number;
    /**
     * 
     * @type {string}
     * @memberof LogDocument
     */
    culture?: string | null;
    /**
     * 
     * @type {DateInterval}
     * @memberof LogDocument
     */
    notifyInterval?: DateInterval;
    /**
     * 
     * @type {Date}
     * @memberof LogDocument
     */
    lastNotification?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof LogDocument
     */
    notificationEmail?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof LogDocument
     */
    notificationEmailConfirmed?: boolean;
    /**
     * 
     * @type {string}
     * @memberof LogDocument
     */
    webhookUrl?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof LogDocument
     */
    webhookNotifyEvery?: boolean;
    /**
     * 
     * @type {number}
     * @memberof LogDocument
     */
    webhookFailCount?: number;
    /**
     * 
     * @type {UptimeCheckDocument}
     * @memberof LogDocument
     */
    uptimeCheck?: UptimeCheckDocument;
    /**
     * 
     * @type {LogType}
     * @memberof LogDocument
     */
    logType?: LogType;
    /**
     * 
     * @type {boolean}
     * @memberof LogDocument
     */
    enableStructuralLogging?: boolean;
    /**
     * 
     * @type {string}
     * @memberof LogDocument
     */
    apiKey?: string | null;
}

/**
 * Check if a given object implements the LogDocument interface.
 */
export function instanceOfLogDocument(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function LogDocumentFromJSON(json: any): LogDocument {
    return LogDocumentFromJSONTyped(json, false);
}

export function LogDocumentFromJSONTyped(json: any, ignoreDiscriminator: boolean): LogDocument {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'logId': !exists(json, 'logId') ? undefined : json['logId'],
        'projectId': !exists(json, 'projectId') ? undefined : json['projectId'],
        'name': json['name'],
        'notifyOnNew': !exists(json, 'notifyOnNew') ? undefined : json['notifyOnNew'],
        'timeZone': !exists(json, 'timeZone') ? undefined : json['timeZone'],
        'timeZoneOffset': !exists(json, 'timeZoneOffset') ? undefined : json['timeZoneOffset'],
        'culture': !exists(json, 'culture') ? undefined : json['culture'],
        'notifyInterval': !exists(json, 'notifyInterval') ? undefined : DateIntervalFromJSON(json['notifyInterval']),
        'lastNotification': !exists(json, 'lastNotification') ? undefined : (json['lastNotification'] === null ? null : new Date(json['lastNotification'])),
        'notificationEmail': !exists(json, 'notificationEmail') ? undefined : json['notificationEmail'],
        'notificationEmailConfirmed': !exists(json, 'notificationEmailConfirmed') ? undefined : json['notificationEmailConfirmed'],
        'webhookUrl': !exists(json, 'webhookUrl') ? undefined : json['webhookUrl'],
        'webhookNotifyEvery': !exists(json, 'webhookNotifyEvery') ? undefined : json['webhookNotifyEvery'],
        'webhookFailCount': !exists(json, 'webhookFailCount') ? undefined : json['webhookFailCount'],
        'uptimeCheck': !exists(json, 'uptimeCheck') ? undefined : UptimeCheckDocumentFromJSON(json['uptimeCheck']),
        'logType': !exists(json, 'logType') ? undefined : LogTypeFromJSON(json['logType']),
        'enableStructuralLogging': !exists(json, 'enableStructuralLogging') ? undefined : json['enableStructuralLogging'],
        'apiKey': !exists(json, 'apiKey') ? undefined : json['apiKey'],
    };
}

export function LogDocumentToJSON(value?: LogDocument | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'logId': value.logId,
        'projectId': value.projectId,
        'name': value.name,
        'notifyOnNew': value.notifyOnNew,
        'timeZone': value.timeZone,
        'timeZoneOffset': value.timeZoneOffset,
        'culture': value.culture,
        'notifyInterval': DateIntervalToJSON(value.notifyInterval),
        'lastNotification': value.lastNotification === undefined ? undefined : (value.lastNotification === null ? null : value.lastNotification.toISOString()),
        'notificationEmail': value.notificationEmail,
        'notificationEmailConfirmed': value.notificationEmailConfirmed,
        'webhookUrl': value.webhookUrl,
        'webhookNotifyEvery': value.webhookNotifyEvery,
        'webhookFailCount': value.webhookFailCount,
        'uptimeCheck': UptimeCheckDocumentToJSON(value.uptimeCheck),
        'logType': LogTypeToJSON(value.logType),
        'enableStructuralLogging': value.enableStructuralLogging,
        'apiKey': value.apiKey,
    };
}

